<template>
  <div>
    <!-- 主圖片區 (輪播圖) -->
    <section id="hero" class="carousel-container">
      <div class="carousel">
        <div
          class="carousel-slide"
          v-for="(image, index) in images"
          :key="index"
          :class="{ active: currentSlide === index }"
        >
          <img :src="image" alt="輪播圖圖片" />
        </div>
      </div>
      <!-- 底部選擇按鈕 -->
      <div class="carousel-indicators">
        <button
          v-for="(image, index) in images"
          :key="index"
          @click="goToSlide(index)"
          :class="{ active: currentSlide === index }"
        ></button>
      </div>
    </section>

    <section class="quickTourBox">
      <div class="quickTourItem">
        <div class="item">
          <div class="numBox">
            <p class="num">01</p>
            <p class="enTitle">LUXURY ROOM</p>
          </div>
          <div class="Txt">
            <div class="subtitle">奢華房型</div>
            <div class="rightSide">
              <div class="title">沉浸自然氛圍 感受純粹寧靜之美</div>
              <div class="textEditor"><p></p></div>
            </div>
          </div>
        </div>
      </div>

      <div class="quickTourItem">
        <div class="item">
          <div class="numBox">
            <p class="num">02</p>
            <p class="enTitle">RESTAURANT</p>
          </div>
          <div class="Txt">
            <div class="subtitle">餐飲美饌</div>
            <div class="rightSide">
              <div class="title">以在地自然食材 打造精緻料理</div>
            </div>
          </div>
        </div>
      </div>

      <div class="quickTourItem">
        <div class="item">
          <div class="numBox">
            <p class="num">03</p>
            <p class="enTitle">FACILITY</p>
          </div>
          <div class="Txt">
            <div class="subtitle">設施服務</div>
            <div class="rightSide">
              <div class="title">靜享森林步道 讓身心完全放鬆</div>
            </div>
          </div>
        </div>
      </div>

      <div class="quickTourItem">
        <div class="item">
          <div class="numBox">
            <p class="num">04</p>
            <p class="enTitle">CITY GUIDE</p>
          </div>
          <div class="Txt">
            <div class="subtitle">森林探索</div>
            <div class="rightSide">
              <div class="title">深入綠意秘境 體驗大自然的奇蹟</div>
            </div>
          </div>
        </div>
      </div>
    </section>

    <section class="about-us">
      <div class="about-us-content">
        <h1>翎藍秘境酒店</h1>
        <p>
          在翎藍秘境酒店，遠離城市喧囂，擁抱森林的寧靜與自然的清新。<br />
          無論是靜謐的綠意步道、溫暖的溫泉泡湯，或是四季變幻中的絕美景致，<br />
          我們為您精心打造與自然和諧共處的專屬體驗，讓每一刻都能放下疲憊、找回自我。<br />

          從日出的晨光到星空下的私密時光，<br />
          翎藍秘境酒店，邀您享受無與倫比的身心之旅。
        </p>
      </div>
    </section>

    <section class="content">
      <!-- 左側內容 -->
      <div class="description">
        <h4>與自然共舞</h4>
        <br />
        <p>
          感受大自然的擁抱，進入絕美的森林秘境。<br />
          每間房間設計以自然為靈感，大片落地窗引入蒼翠景緻，享受森林的寧靜與盎然生機。
        </p>
      </div>

      <!-- 右側內容 -->
      <div class="highlight">
        <h4>沉浸於自然的溫柔懷抱</h4>
        <br />
        <p>
          逃離都市喧囂，在天然溫泉中釋放壓力，感受大自然帶來的療癒力量。<br />
          溫泉區結合木質溫暖的設計風格，俯瞰大自然美景，讓您的每一次呼吸都充滿能量。
        </p>
      </div>
    </section>

    <!-- 圖片與文字區塊 -->
    <section class="image-text-section">
      <!-- 左側圖片 -->
      <div class="image-box">
        <img src="@/assets/picture/spring-4.jpg" alt="森林圖" />
      </div>

      <!-- 右側文字內容 -->
      <div class="text-content">
        <h3>恣意享受，回歸自然</h3>
        <br />
        <h4>探索這片林間的氣息，獲抱過往的軌跡。</h4>
        <br />
        <p>
          我們座落於一片翠綠的山林間，春夏秋冬皆有獨特的景色。<br />
          春天，綠意盎然；夏季，清涼宜人；秋冬時節，溫泉氣息四溢。<br />
          這裡的每一個角落，都讓人感受到大自然的愉悅與舒適。<br /><br />
          讓每一位旅客在此地回歸純粹的生活樂趣。<br />
          無論是想要遠離城市喧囂的休憩，或是尋求健康療癒的旅程，<br />
          都能在我們這裡體驗大自然的無限美好。
        </p>
      </div>
    </section>

    <section class="news-section">
      <div class="news-left">
        <h4 class="news-englishtitle">NEWS</h4>
        <h3 class="news-chinesetitle">最新消息</h3>
        <!-- 標籤列 -->
        <div class="tab-bar">
          <div
            v-for="filter in filters"
            :key="filter"
            class="tab-item"
            :class="{ active: activeFilter === filter }"
            @click="filterNews(filter)"
          >
            {{ filter }}
          </div>
        </div>
        <div class="news-controls">
          <!--左按鈕 -->
          <button class="circle-button" @click="previousNews">
            <span class="arrow left">&lt;</span>
          </button>

          <!-- 右按鈕 -->
          <button class="circle-button" @click="nextNews">
            <span class="arrow right">&gt;</span>
          </button>
        </div>
        <button class="more-button mobile-actions" @click="goToNewsPage">
          了解更多
        </button>
      </div>
      <div class="news-right">
        <div
          v-for="(news, index) in visibleNews"
          :key="index"
          class="news-card"
          @click="goToNewsPage(news.id)"
        >
          <img :src="news.image" alt="新聞圖片" class="news-image" />
          <div class="news-content">
            <p class="news-title">{{ news.title }}</p>
          </div>
          <div class="news-date-wrapper">
            <i class="fas fa-clock"></i>
            <p class="news-date">活動期間：{{ news.date }}</p>
          </div>
        </div>
        <!-- ✅ 手機版：了解更多（放在 news-right 底部） -->
        <div class="news-more-mobile">
          <button class="more-button" @click="goToNewsPage">了解更多</button>
        </div>
      </div>
    </section>

    <!-- 交通資訊區塊 -->
    <section class="info-section">
      <div class="info-content">
        <h2 class="info-p">酒店位置</h2>
        <br />
        <h3>交通資訊</h3>
        <p class="info-p">
          本飯店位於山林間，遠離都市塵囂，為您提供舒適且寧靜的住宿體驗。<br />
          飯店附設停車場，交通便利，讓您輕鬆抵達，享受大自然的寧靜氛圍。
        </p>

        <h3>停車資訊</h3>
        <p class="info-p">
          飯店附設專屬停車場，旅客可直接駕車前往。<br />
          停車場位於地下一樓至地下二樓，提供充足車位，適合自駕旅客入住。
        </p>

        <h3>搭乘大眾交通工具</h3>
        <p class="info-p">搭乘捷運至鄰近車站，並由指定接駁車接送至飯店。</p>
        <ul class="info-list">
          <li>捷運抵達新店站一號出口後，請前往接駁車候車處。</li>
          <li>每日提供定時接駁服務，車程約 15 分鐘即可抵達飯店。</li>
        </ul>
        <p class="info-p">如需接駁車時刻表或預約服務，請提前聯繫飯店前台。</p>
      </div>
    </section>
  </div>
</template>

<script>
import {
  loadImages,
  goToSlide,
  startAutoSlide,
  stopAutoSlide,
  nextSlide,
} from "@/assets/js/homepageLogic.js";
import newsLogic from "@/assets/js/newsLogic.js";

export default {
  name: "HomePage",
  mixins: [newsLogic],

  data() {
    return {
      currentSlide: 0,
      images: [],
      autoSlideInterval: null,
      autoRotateInterval: null,
    };
  },

  computed: {
    visibleNews() {
      if (this.currentNewsIndex + 3 > this.newsList.length) {
        return [
          ...this.newsList.slice(this.currentNewsIndex),
          ...this.newsList.slice(
            0,
            this.currentNewsIndex + 3 - this.newsList.length
          ),
        ];
      }
      return this.newsList.slice(
        this.currentNewsIndex,
        this.currentNewsIndex + 3
      );
    },
  },

  methods: {
    goToSlide,
    nextSlide,
    loadImages,
    startAutoSlide,
    stopAutoSlide,
    goToNewsPage(newsId) {
      this.$router.push({
        path: "/news",
        query: { id: newsId },
      });
    },
    previousNews() {
      if (this.currentNewsIndex === 0) {
        this.currentNewsIndex = this.newsList.length - 3;
      } else {
        this.currentNewsIndex--;
      }
    },
    nextNews() {
      if (this.currentNewsIndex >= this.newsList.length - 3) {
        this.currentNewsIndex = 0;
      } else {
        this.currentNewsIndex++;
      }
    },
    onResize() {
      const newImages = this.loadImages();
      if (JSON.stringify(newImages) !== JSON.stringify(this.images)) {
        this.images = newImages;
      }
    },
    startAutoRotate() {
      this.autoRotateInterval = setInterval(() => {
        this.nextNews();
      }, 6000);
    },
    stopAutoRotate() {
      clearInterval(this.autoRotateInterval);
      this.autoRotateInterval = null;
    },
  },

  mounted() {
    this.images = this.loadImages();
    this.startAutoSlide();
    this.startAutoRotate();
    window.addEventListener("resize", this.onResize);
  },

  beforeDestroy() {
    this.stopAutoSlide();
    this.stopAutoRotate();
    window.removeEventListener("resize", this.onResize);
  },
};
</script>

<style src="@/assets/css/homepage.css" scoped></style>
<style src="@/assets/css/news-section.css" scoped></style>
